module.exports = "<div ui-view></div>"


//////////////////
// WEBPACK FOOTER
// ./src/views/layouts/nested.html
// module id = 5
// module chunks = 0